import { Injectable } from '@angular/core';
import { injectMutation, injectQuery, QueryKey } from '@tanstack/angular-query-experimental';
import { firstValueFrom, lastValueFrom } from 'rxjs';
import { TodoTask, TodoTaskAS } from '../models/todoTask.model';
import { BaseApiService } from './base.api.service';

@Injectable({ providedIn: 'root' })
export class TodoTaskService extends BaseApiService {
  private myTasks: QueryKey = ['myTasks'];
  private informationsAs: QueryKey = ['informationsAs'];

  getListTasks() {
    return injectQuery(() => ({
      queryKey: this.myTasks,
      queryFn: async () => {
        try {
          return await lastValueFrom(
            this.httpClient.get<TodoTask[]>(
              `${this.baseUrl}/api/core/TodoTasks`,
              {
                withCredentials: true,
              }
            )
          );
        } catch (error: any) {
          this.handleError(error);
          throw error;
        }
      },
    }));
  }

  getListInformations() {
    return injectQuery(() => ({
      queryKey: this.informationsAs,
      queryFn: async () => {
        try {
          return await lastValueFrom(
            this.httpClient.get<TodoTaskAS[]>(
              `${this.baseUrl}/api/core/TodoTasksAS`,
              {
                withCredentials: true,
              }
            )
          );
        } catch (error: any) {
          this.handleError(error);
          throw error;
        }
      },
    }));
  }

  updateTaskRealisee = injectMutation(() => ({
    mutationKey: ['updateTaskRealisee'],
    mutationFn: async ({ id, task }: { id: string; task: TodoTask }) => {
      try {
        const response = await firstValueFrom(
          this.httpClient.put<TodoTask>(
            `${this.baseUrl}/api/core/TodoTasks/${id}`,
            task,
            { withCredentials: true }
          )
        );
        this.queryClient.invalidateQueries({ queryKey: this.myTasks });
        return response;
      } catch (error: any) {
        this.handleError(error);
        throw error;
      }
    },
  }));
}
